import { motion } from "framer-motion";
import { springs } from "../motion";
import type { FilterChipsProps } from "./types";

export function FilterChips<T = string>({
  chips,
  activeFilter,
  onFilterChange,
  layoutId = "activeFilterBg",
  className = "flex items-center gap-2 overflow-x-auto pb-1 scrollbar-none",
  multiSelect = false,
  selectedIds,
}: FilterChipsProps<T>) {
  return (
    <div className={className}>
      {chips.map((chip) => {
        // In multi-select mode, check if the chip is in selectedIds
        const isActive = multiSelect
          ? selectedIds?.includes(String(chip.id))
          : activeFilter === chip.id;

        return (
          <button
            key={String(chip.id)}
            type="button"
            onClick={() => onFilterChange(chip.id)}
            className={`relative flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12px] font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isActive ? "text-white font-semibold" : "hover:font-semibold"
            }`}
          >
            {/* Active background pill */}
            {isActive && (
              <motion.div
                layoutId={
                  multiSelect ? `${layoutId}-${String(chip.id)}` : layoutId
                }
                className="absolute inset-0 rounded-full bg-accent"
                transition={springs.snappy}
              />
            )}

            <span className="relative">{chip.label}</span>

            <motion.span
              key={`${String(chip.id)}-${chip.count}`}
              className={`relative text-[12px] tabular-nums ${
                isActive ? "text-white/80" : "text-muted"
              }`}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={springs.snappy}
            >
              {chip.count}
            </motion.span>
          </button>
        );
      })}
    </div>
  );
}
